<template v-slot:activator="{ on, attrs }">
  <v-hover v-slot="{ hover }">
    <v-card
      class="card-hover pa-4 overflow-hidden card-container d-flex flex-column justify-space-between"
      link
      height="186"
      outlined
      @click="goToTeam"
    >
      <div>
        <div class="d-flex">
          <v-tooltip top max-width="250">
            <template v-slot:activator="{ on }">
              <text-highlight
                data-testid="teamView-text-name"
                highlightClass="yellow lighten-1"
                data-private
                v-on="on"
                class="text-truncate blue-grey--text text--darken-3 mb-1 font-size-16 font-weight-600"
                :queries="highlightTerm"
                >{{ team.name }}</text-highlight
              >
            </template>
            {{ team.name }}
          </v-tooltip>
          <v-tooltip v-if="!team.site" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                class="ms-2"
                size="20"
                :color="hover ? 'primary' : 'blue-grey lighten-1'"
                >mdi-web</v-icon
              >
            </template>

            {{ $t('teams.global_team') }}
          </v-tooltip>
        </div>
        <text-highlight
          v-if="team.description"
          class="description text-caption blue-grey--text text--darken-1 mr-2"
          data-testid="teamView-text-description"
          highlightClass="yellow lighten-1"
          data-private
          :queries="highlightTerm"
          highlightComponent="span"
          >{{ team.description }}</text-highlight
        >
      </div>

      <div class="d-flex flex-column">
        <v-menu v-if="totalMembers > 0" open-on-hover max-width="230">
          <template v-slot:activator="{ on, attrs }">
            <p v-bind="attrs" v-on="on" class="primary--text text-caption my-2">
              {{ totalMembers }}
              {{ $t('teams.member', { count: totalMembers }) }}
            </p>
          </template>

          <v-card
            class="ma-0 px-4 pt-4 pb-1 blue-grey lighten-3 hover-card"
            dense
            elevation="2"
          >
            <p
              v-for="(name, index) in memberNames"
              class="ma-0 pa-0 label mb-3 blue-grey--text text--darken-2 font-weight-400"
              :key="`${name}${index}`"
            >
              {{ name }}
            </p>
          </v-card>
        </v-menu>

        <p v-else class="text-caption blue-grey--text mb-2">
          {{ $t('teams.no_members') }}
        </p>

        <div class="d-flex align-end justify-space-between">
          <LeaderList :leaders="team.leaders" />

          <div class="d-flex align-center">
            <TeamOptions
              class="mr-n2"
              :team="team"
              @deleted="handleDelete"
              @updated="handleUpdate"
            />
          </div>
        </div>
      </div>
    </v-card>
  </v-hover>
</template>

<script>
import userMixin from '@/mixins/userMixin.vue'
import trackerMixin from '@/mixins/tracking/trackerMixin.vue'
import mixin from '@/mixins/mixin.vue'

import TeamOptions from '@/components/TeamOptions/TeamOptions.vue'
import LeaderList from './LeaderList.vue'

export default {
  name: 'TeamCard',

  mixins: [userMixin, trackerMixin, mixin],

  props: {
    team: {
      type: Object,
      required: true,
    },
    highlightTerm: {
      type: String,
      default: '',
    },
  },

  components: {
    LeaderList,
    TeamOptions,
  },

  computed: {
    totalMembers() {
      return this.team.members?.length
    },

    memberNames() {
      return this.team.members?.map(this.getFullName) ?? []
    },
  },

  methods: {
    handleDelete() {
      this.trackTeamDelete({ view: 'stream' })
      this.$emit('deleted')
    },

    handleUpdate(e) {
      this.trackTeamEdit({ view: 'stream' })
      this.$emit('updated', e)
    },

    goToTeam() {
      this.navigateTo({
        name: 'teamDetails',
        params: { teamId: this.team?.id ?? this.team?._id },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.card-container {
  .description {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 16px;
  }
}
.hover-card {
  max-height: 250px;
  overflow-y: scroll;
  border: 1px solid $color-blue-grey-lighten1 !important;
}
</style>
